



















































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() itm!: any;

  @Prop() idx!: number;

  @Prop() addControlRule!: (...args: any[]) => any;

  @Prop() removeControlRule!: (...args: any[]) => any;

  @Prop() removeSwitchItem!: (...args: any[]) => any;

  mounted(){
    console.log('itm:',this.itm,this.idx)
  }

  getSn(i:number):any {
    if(i==0){
      return "A、"
    }
    if(i==1){
      return "B、"
    }
    if(i==2){
      return "C、"
    }
    if(i==3){
      return "D、"
    }
    return (i+1)
  }
}
